import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { street, cityAndZip } from 'shared/models/address';
import { setAddress } from 'components/address/actions';
import Address from 'scy/Address';
import Dropdown from 'components/ui/dropdown';
import AddressEntryBg from 'images/set-location.svg';
import Triangle from 'images/icons/controls/triangle-down.svg?react-svg';
import { SecondarySmall } from 'scy/text';
import { accent, tablet_body } from 'scy/text/styles.mod.scss';
import { hidden, tablet_block } from 'scy/display.mod.scss';
import styles from './address.mod.scss';
import { width100, textOverflow } from 'scy/utils.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';

function HeaderAddress({
  setAddress,
  trackingParams,
  address,
  city,
  state,
  zip,
  className
}) {
  const displayAddress =
    street({ address }) ||
    cityAndZip({
      city,
      state,
      zip
    });

  return (
    <Dropdown>
      {({ isOpen, triggerRef, contentRef, forceClose }) => (
        <div className={classnames(styles.container, className)}>
          <a className={styles.address} ref={triggerRef}>
            <div className={styles.display}>
              <SecondarySmall
                tag="div"
                className={classnames(hidden, tablet_block)}
              >
                Deliver ASAP to
              </SecondarySmall>
              <div className={classnames(accent, tablet_body, textOverflow)}>
                {displayAddress ? displayAddress : 'Enter a Delivery Address'}
              </div>
            </div>
            <div className={styles.arrowIconContainer}>
              <Triangle />
            </div>
          </a>
          {isOpen && (
            <div className={styles.content} ref={contentRef}>
              <Address
                id="header-address-input"
                className={margin.sides_auto}
                onSuccess={address => {
                  return setAddress(address, trackingParams).then(() => {
                    forceClose();
                  });
                }}
                defaultValue={displayAddress}
              />
              <img
                className={classnames(width100, padding.md)}
                src={AddressEntryBg}
              />
            </div>
          )}
        </div>
      )}
    </Dropdown>
  );
}

function mapStateToProps(state) {
  return {
    address: state.address.address,
    city: state.address.city,
    state: state.address.state,
    zip: state.address.zip
  };
}

export default connect(
  mapStateToProps,
  { setAddress }
)(HeaderAddress);
